import { forwardRef, useEffect, useState } from "react";
import { Section } from "../components/Layout/Section";
import { Container } from "../components/Layout/Container";
import styled from "@emotion/styled";
import Projekt from "../components/Projekt";
import { useApp } from "../AppProvider";
import { collection } from "@firebase/firestore";
import { getDocs } from "@firebase/firestore";
import SectionTitle from "../components/SectionTitle";

const ProjectWrapper = styled("div")(() => ({
  display: "grid",
  gridTemplateColumns: "repeat(1, 1fr)",
  "@media (min-width: 768px)": {
    gridTemplateColumns: "repeat(2, 1fr)",
  },
  "@media (min-width: 1260px)": {
    gridTemplateColumns: "repeat(4, 1fr)",
  },
  "@media (min-width: 1920px)": {
    gridTemplateColumns: "repeat(5, 1fr)",
  },
  gap: "1rem",
}));

type ProjektType = {
  url: string;
  image: string;
  title: string;
  order: number;
  size: "normal" | "large";
};

export const Projekte = forwardRef<HTMLDivElement, unknown>((props, ref) => {
  const [projekte, setProjekte] = useState<ProjektType[]>([]);
  const { cookiesAccepted, db } = useApp();

  useEffect(() => {
    let cancel = false;

    if (cookiesAccepted === undefined || !db) {
      return;
    }

    getDocs(collection(db, "projekte"))
      .then((querySnapshot) => {
        const newProjekte: ProjektType[] = [];
        querySnapshot.forEach((doc) => {
          const data = doc.data() as ProjektType;
          data.title = doc.id;
          newProjekte.push(data);
        });
        if (!cancel) {
          setProjekte(
            newProjekte.sort((a, b) => {
              return a.order - b.order;
            })
          );
        }
      })
      .catch((error) => console.log(error.message));

    return () => {
      cancel = true;
    };
  }, [cookiesAccepted, db]);

  return (
    <Section ref={ref} id={"projekte"}>
      <Container>
        <SectionTitle>Projekte</SectionTitle>
        <ProjectWrapper>
          {projekte.map((projekt) => (
            <Projekt {...projekt} key={projekt.title} />
          ))}
        </ProjectWrapper>
      </Container>
    </Section>
  );
});
